import React, { Component } from "react";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Glyphicon } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";

import {
  formatDate,
  formatDateWithoutTimezone
} from "../../../../../utils/dates";

import styles from "./AdminProjectSow.scss";

class AdminProjectSow extends Component {
  renderBothPartiesAgree(workTypeId) {
    if (workTypeId === 70) {
      // Remote
      return " Both parties agree the Member will work remotely.";
    } else if (workTypeId === 71) {
      // On Site
      return " Both parties agree the Member will NOT work remotely.";
    } else if (workTypeId === 72) {
      // Both
      return " Both parties agree the Member will work both on site and remotely.";
    }
  }

  renderTaxStatus(taxStatus, memberName, companyName) {
    let message = "No option selected.";

    switch (taxStatus) {
      case "1099":
        message = `${memberName} will be a 1099 worker of The Second Shift for this project.`;
        break;

      case "W-2":
        message = `${memberName} will be a W-2 employee of ${companyName} for this job.`;
        break;
    }

    return message;
  }

  render() {
    const {
      projectId,
      sowData,
      rateTypes,
      rateType,
      sowAceppted,
      member,
      employer
    } = this.props;
    const { id } = sowData;

    const rateTypePlural = () => {
      if (rateType && rateType.value) {
        switch (rateType.value) {
          case "Project":
            return "total";
          case "Annual":
            return "per year";
          case "Hourly":
            return "per hour";
          case "Daily":
            return "per day";
          case "Weekly":
            return "per week";
          case "Monthly":
            return "per month";
          case "Negotiable":
            return null;
        }
      }
    };

    const determineRateType = _.get(rateTypes)
      ? rateTypes.find(rate => {
          return rate.id === sowData.budget_rate_type_id;
        })
      : null;

    const memberName = member
      ? `${_.get(member, "first_name")} ${_.get(member, "last_name")}`
      : "Member";

    const companyName = _.get(employer, "profile.company.name") || "company";

    return (
      <div className={styles.projectSow}>
        <Row>
          <div className={styles.titleBlock}>
            <h1>{memberName}</h1>
            <span className={styles.signedAndCreated}>
              {sowAceppted
                ? "Accepted by Employer on "
                : "Submitted by Member on "}
              {formatDate(sowData.updated_at, "MMM D, Y h:mm A")}
            </span>
          </div>
          <div className={styles.subTitle} />
        </Row>

        <Row>
          <div className={styles.divider} />
          <div className={styles.divider} />
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Project Summary</h2>
          <Link to={`/admin/project/${projectId}/sow/${id}/edit`}>
            <Glyphicon className={styles.iconLink} glyph="pencil" />
            Edit
          </Link>
        </Row>
        <Row>
          <div className={styles.whiteSection}>
            {ReactHtmlParser(sowData.summary)}
          </div>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Deliverables + Milestones</h2>
        </Row>
        <Row>
          <div className={styles.whiteSection}>
            {ReactHtmlParser(sowData.deliverables)}
          </div>
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Location</h2>
        </Row>
        <Row className={styles.whiteSection}>
          The company’s office is located in {sowData.city}
          {sowData.state != null ? ", " + sowData.state + "." : "."}
          {this.renderBothPartiesAgree(sowData.work_type_id)}
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Project Run</h2>
        </Row>
        <Row className={styles.whiteSection}>
          The Project is contracted to run from{" "}
          {formatDateWithoutTimezone(sowData.project_start, "MMM D, Y")}, to{" "}
          {sowData.project_end === undefined
            ? "N/A"
            : formatDateWithoutTimezone(sowData.project_end, "MMM D, Y")}
          .
          {sowData.project_period &&
            ` The Member agrees to work ${
              sowData.project_period
            } hours per week.`}
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Project Fee</h2>
        </Row>
        <Row className={styles.whiteSection}>
          The agreed-upon rate is{" "}
          {_.get(determineRateType, "value") === "Negotiable"
            ? "Negotiable"
            : "$" + sowData.budget_rate_value}
          &nbsp;
          {rateTypePlural()}. By accepting this SOW, you agree to The Second
          Shift invoice terms and fees.
        </Row>

        <Row className={styles.sectionHeader}>
          <h2 className={styles.headerText}>Tax Status</h2>
        </Row>
        <Row className={styles.whiteSection}>
          {this.renderTaxStatus(
            _.get(sowData, "tax_status.value"),
            memberName,
            companyName
          )}
        </Row>
      </div>
    );
  }
}

export default AdminProjectSow;



// WEBPACK FOOTER //
// ./src/routes/admin/project/sow/components/AdminProjectSow.js